import { observer } from "mobx-react-lite";
import Projects from "../../components/financier/projects/Projects";
import FinancierSharedView from "../shared/FinancierSharedView";

export default observer(function FinancierProjects() {
  return <FinancierSharedView mainContent={<Projects />} />;
});
